module.exports = __webpack_public_path__ + "static/media/Paramedical Sciences.44226a55.png";